import classNames from 'classnames';
import { Portal, svgSprite } from '../../hybrid/wrappers';
import css from './Modal.module.scss';

export default function Modal({ closeHandler, children, useAnimation, customStyles = {} }) {
    return (
        <Portal closeHandler={closeHandler}>
            <div className={classNames(css.modal, useAnimation && css.modalAnimation, customStyles?.modal)}>
                <div onClick={closeHandler} className={classNames('circleButtonSmall', css.modalClose)}>
                    {svgSprite('cross')}
                </div>
                {children}
            </div>
        </Portal>
    );
}
